import React from 'react';
import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { terraformCloudApiRef } from './api';
import { TerraformCloudClient } from './api';

export const terraformCloudPlugin = createPlugin({
  id: 'terraform-cloud',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: terraformCloudApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ configApi, discoveryApi, fetchApi, identityApi }) =>
        new TerraformCloudClient({ 
          configApi, 
          discoveryApi, 
          fetchApi, 
          identityApi 
        }),
    }),
  ],
});

// Export the routable extension for plugin installation
export const TerraformCloudPageExtension = terraformCloudPlugin.provide(
  createRoutableExtension({
    name: 'TerraformCloudPage',
    component: () =>
      import('./components/TerraformCloudPage').then(m => m.TerraformCloudPage),
    mountPoint: rootRouteRef,
  }),
);

// Export a simple component wrapper for direct use in routes
// This avoids the AppProvider context issue
export const TerraformCloudPage = () => {
  const LazyComponent = React.lazy(() =>
    import('./components/TerraformCloudPage').then(module => ({
      default: module.TerraformCloudPage,
    }))
  );

  return (
    <React.Suspense fallback={<div>Loading Terraform Cloud...</div>}>
      <LazyComponent />
    </React.Suspense>
  );
};
